import React, { useEffect, useState } from 'react';
import ApiClient from '../../helpers/ApiClient';
import { toast } from 'react-hot-toast';
import { IconPlus, IconTrash, IconArrowLeft, IconPackage } from '@tabler/icons-react';
import Page from "../../components/Page";
import { Link } from 'react-router-dom';

export default function PurchaseUnitsPage() {
  const [units, setUnits] = useState([]);
  const [name, setName] = useState('');
  const [symbol, setSymbol] = useState('');
  const [unitType, setUnitType] = useState('COUNT');

  const fetchUnits = async () => {
    try {
      const res = await ApiClient.get('/settings/purchase-units');
      setUnits(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      toast.error('Failed to load purchase units');
    }
  };

  useEffect(() => {
    fetchUnits();
  }, []);

  const handleCreate = async () => {
    if (!name || !symbol) return toast.error('Name and Symbol required');
    try {
      await ApiClient.post('/settings/purchase-units', { name, symbol, unit_type: unitType });
      toast.success('Purchase unit created');
      setName('');
      setSymbol('');
      fetchUnits();
      try { document.getElementById('modal-add-unit')?.close(); } catch(e){}
    } catch (error) {
      const msg = error?.response?.data?.message || 'Failed to create purchase unit';
      toast.error(msg);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this purchase unit?")) return;
    try {
      await ApiClient.delete(`/settings/purchase-units/${id}`);
      toast.success("Purchase unit deleted");
      fetchUnits();
    } catch (error) {
      toast.error("Failed to delete purchase unit");
    }
  };

  return (
    <Page className="px-4 py-4 md:px-8 md:py-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Link 
              to="/dashboard/inventory/unit-conversions"
              className="text-xs text-restro-green hover:underline flex items-center gap-1 font-semibold"
            >
              <IconArrowLeft size={14} /> Back to Unit Conversions
            </Link>
          </div>
          <h1 className="text-2xl font-bold flex items-center gap-2 text-restro-text">
            <IconPackage className="text-restro-green" size={28} />
            Packaging & Purchase Units
          </h1>
          <p className="text-gray-500 text-sm">Define bulk units (Bottle, Box, Case, Can, Keg, Sack) used in unit conversions and purchases.</p>
        </div>
        <button className="btn btn-sm bg-restro-green hover:bg-restro-green-button-hover text-white border-none rounded-xl flex items-center gap-1 font-bold" onClick={() => document.getElementById('modal-add-unit')?.showModal()}>
          <IconPlus size={18} /> Add Unit
        </button>
      </div>

      <div className="bg-white dark:bg-zinc-900 border border-restro-border-green rounded-2xl overflow-hidden shadow-sm">
        <table className="table w-full">
          <thead>
            <tr className="bg-restro-bg-gray border-b border-restro-border-green">
              <th>Name</th>
              <th>Symbol</th>
              <th>Type</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {units.map((u) => (
              <tr key={u.id} className="border-b border-gray-100 dark:border-zinc-800">
                <td className="font-bold text-restro-text">{u.name}</td>
                <td><span className="badge badge-sm font-semibold">{u.symbol}</span></td>
                <td><span className="text-xs text-gray-500 uppercase font-semibold">{u.unit_type}</span></td>
                <td className="text-end">
                  <button onClick={() => handleDelete(u.id)} className="btn btn-error btn-xs btn-square btn-ghost text-red-500">
                    <IconTrash size={16} />
                  </button>
                </td>
              </tr>
            ))}
            {units.length === 0 && (
              <tr><td colSpan="4" className="text-center py-6 text-gray-500">No purchase units defined.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <dialog id="modal-add-unit" className="modal modal-bottom sm:modal-middle">
        <div className="modal-box border border-restro-border-green dark:bg-zinc-900 rounded-2xl">
          <h3 className="font-bold text-lg mb-4 text-restro-text">Add Packaging / Purchase Unit</h3>
          <div className="form-control mb-4">
            <label className="label"><span className="label-text">Name (e.g. Bottle, Case, Box, Keg, Sack)</span></label>
            <input type="text" className="input input-sm input-bordered w-full rounded-xl" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Bottle" />
          </div>
          <div className="form-control mb-4">
            <label className="label"><span className="label-text">Symbol (e.g. btl, case, box, keg)</span></label>
            <input type="text" className="input input-sm input-bordered w-full rounded-xl" value={symbol} onChange={e => setSymbol(e.target.value)} placeholder="e.g. btl" />
          </div>
          <div className="form-control mb-4">
            <label className="label"><span className="label-text">Type</span></label>
            <select className="select select-sm select-bordered w-full rounded-xl" value={unitType} onChange={e => setUnitType(e.target.value)}>
              <option value="COUNT">Count (Bottles, Boxes, Cartons, Cans, Kegs)</option>
              <option value="VOLUME">Volume (Litres, Barrels, Gallons)</option>
              <option value="WEIGHT">Weight (Sacks, Bags, Kilograms)</option>
            </select>
          </div>
          <div className="modal-action">
            <form method="dialog">
              <button className="btn btn-sm btn-ghost mr-2 rounded-xl">Cancel</button>
              <button className="btn btn-sm bg-restro-green hover:bg-restro-green-button-hover text-white rounded-xl border-none font-bold" onClick={(e) => { e.preventDefault(); handleCreate(); }}>Save</button>
            </form>
          </div>
        </div>
      </dialog>
    </Page>
  );
}
